import toastr from 'toastr';
import '../../../../node_modules/toastr/build/toastr.css';

toastr.options = {
  preventDuplicates: true,
  timeOut: 10000,
  extendedTimeOut: 10000,
  closeButton: true,
  positionClass: 'toast-top-right'
};

export default toastr;
